import React, { memo, useState, useEffect } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { Social } from '../../interfaces/enums/Social';
import SocialShareBtnGenerator from '../SocialShareBtnGenerator/SocialShareBtnGenerator';
import { storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';

export interface SharePageBarBlokProps extends Blok {
  label: string;
  social_share_buttons: Social[];
  needsThinSpan: boolean;
}

interface SharePageBarProps {
  blok: SharePageBarBlokProps;
}

const SharePageBar: React.FC<SharePageBarProps> = ({ blok }) => {
  const { label, social_share_buttons, needsThinSpan } = blok;
  const [copySuccess, setCopySuccess] = useState(false);
  const [currentUrl, setCurrentUrl] = useState<string>('');
  useEffect(() => {
    setCurrentUrl(window.location.href);
  });

  return (
    <section {...storyblokEditable(blok)}>
      <Container>
        <Grid>
          <Col
            span={{
              md: needsThinSpan ? 10 : 'auto',
              xl: needsThinSpan ? 8 : 'auto',
            }}
            start={{
              md: needsThinSpan ? 2 : 'auto',
              xl: needsThinSpan ? 3 : 'auto',
            }}
          >
            <div className="sm:flex justify-between border-t border-border/disabled pt-6 pb-20 mt-12 sm:mt-16 xl:pb-28">
              {label && (
                <p className="font-semibold text-text/body pb-4 sm:pb-0">
                  {label}
                </p>
              )}
              <div className="flex justify-start sm:justify-end items-center space-x-3">
                <button
                  className="py-2.5 px-4 w-[130px] text-text/body hover:text-[white] text-sm font-bold border border-border/disabled flex justify-start items-center leading-none transition-all ease-in-out duration-300 cursor-pointer focus:ring-0 focus:outline-none fit-content group hover:bg-text/body"
                  aria-label="Copy link"
                  onClick={() => {
                    navigator.clipboard.writeText(currentUrl);
                    setCopySuccess(true);
                  }}
                >
                  <div
                    className="h-[20px] w-[20px] bg-no-repeat bg-text/body group-hover:bg-[white] mr-2 transition-all"
                    style={{
                      WebkitMaskImage: "url('/svgs/copy-to-clipboard.svg')",
                      maskImage: "url('/svgs/copy-to-clipboard.svg')",
                    }}
                  />
                  {copySuccess ? 'Copied!' : 'Copy Link'}
                </button>
                {social_share_buttons.map((social_share_button: Social) => (
                  <SocialShareBtnGenerator
                    key={social_share_button}
                    social={social_share_button}
                    url={currentUrl}
                  />
                ))}
              </div>
            </div>
          </Col>
        </Grid>
      </Container>
    </section>
  );
};

export default memo(withBlokWrapper(SharePageBar, Theme.LIGHT));
